const {floor} = Math

export default (target) => (max, value) => floor((value / max) * target)



/** WEBPACK FOOTER **
 ** ./lib/normalize.js
 **/